import RootContainer from '../../containers/Root';

const RouteRootContainer = () => {
    return <RootContainer />;
};

export default RouteRootContainer;
